<template>
	<md-toolbar md-elevation="0" class="md-transparent">
		<div class="md-toolbar-row">
			<div class="md-toolbar-section-start">
				<!-- <h3 class="md-title">{{$store.state.authentication.name}}</h3> -->
			</div>
			<div class="md-toolbar-section-end">
				<!-- <md-button class="md-just-icon md-simple md-toolbar-toggle" :class="{ toggled: $sidebar.showSidebar }"
					@click="toggleSidebar">
					<span class="icon-bar"></span>
					<span class="icon-bar"></span>
					<span class="icon-bar"></span>
				</md-button> -->
				<md-button class="md-just-icon md-simple" @click="switchLang('km')">
					<img src="@/assets/img/km.png" />
					<!-- <md-tooltip md-direction="top">ភាសាខ្មែរ</md-tooltip> -->
				</md-button>
				<md-button class="md-just-icon md-simple" @click="switchLang('en')">
					<img src="@/assets/img/en.png" />
					<!-- <md-tooltip md-direction="top">English</md-tooltip> -->
				</md-button>
				<md-list>
					<a href="https://cambodiatechex.gov.kh">
					<md-list-item alt="Back to main menu">
						<i class="material-icons">home</i>
						<!-- <p class="hidden-lg hidden-md">Dashboard</p> -->
						<!-- <md-tooltip md-direction="top">Main Menu</md-tooltip> -->
					</md-list-item>
				</a>
				</md-list>
				<!-- <div class="md-collapse">

				</div> -->
			</div>
		</div>

	</md-toolbar>
</template>

<script>
	export default {
		data() {
			return {

			}
		},
		created() {
		},
		methods: {
			toggleSidebar() {
				this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
			},
			switchLang(lang) {
				this.$store.commit('locale/changeLanguage', lang)
				this.$cookie.set('lang', lang, 30);
			},
			logout() {
				this.$store.state.authentication.loggedIn = false
				this.$store.state.authentication.authToken = null
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Layout/TopNavbar.vue